import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChartLine, 
  faTimes, 
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import styles from './TraderDashboard.module.css';

const ActionButtons = ({
  isJobRunning,
  isJobCompleted,
  onCancel,
  onDownload,
  canDownload,
  onSubmit,
  hideRunButton = false, // NEW PROP
}) => {
  const handleSubmitClick = (e) => {
    if (e) e.preventDefault();
    onSubmit(e);
  };

  return (
    <>
      {/* Main Action Button - HIDDEN when AI panel is open */}
      {!isJobRunning && !isJobCompleted && !hideRunButton && (
        <button type="submit" onClick={handleSubmitClick} className={`${styles.button} ${styles.primaryButton}`}>
          <FontAwesomeIcon icon={faChartLine} />
          <span>Run Backtest</span>
        </button>
      )}
      
      {/* Cancel Button - ONLY when job is actually running */}
      {isJobRunning && (
        <button type="button" onClick={onCancel} className={`${styles.button} ${styles.cancelButton}`}>
          <FontAwesomeIcon icon={faTimes} />
          <span>Cancel</span>
        </button>
      )}
      
      {/* Download Button */}
      {isJobCompleted && (
        <button 
          type="button" 
          onClick={onDownload} 
          className={`${styles.button} ${styles.downloadButton}`}
          disabled={!canDownload}
        >
          <FontAwesomeIcon icon={faDownload} />
          <span>Download Results</span>
        </button>
      )}
    </>
  );
};

ActionButtons.propTypes = {
  isJobRunning: PropTypes.bool.isRequired,
  isJobCompleted: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  canDownload: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  hideRunButton: PropTypes.bool, 
};

export default ActionButtons;